{
  "titles": {
    "payments": "Betalingen",
    "feeOverview": "Bemiddelingsfee overzicht",
    "invoice": "Factuur",
    "invoiceSpecification": "Factuurspecificatie"
  },
  "messages": {
    "noPayments": "Er is nog geen uitbetaling gedaan"
  },
  "fields": {
    "labels": {
      "approve": "Betaalbatch in Twikey is doorgestuurd naar de bank"
    }
  },
  "paymentBatch": {
    "title": "Uitbetalingen accorderen",
    "summary": {
      "amount": "Bedrag",
      "expectedAmount": "Verwacht bedrag",
      "count": "Aantal",
      "expectedCount": "Verwacht aantal",
      "interest": "Rente",
      "finalPayment": "Eindafrekening",
      "partnerFee": "Partnerfee",
      "loanPayment": "Leningen",
      "total": "Totaal",
      "errorTotal": "Aantal fouten",
      "isTheSame": "Hetzelfde"
    },
    "errors": {
      "name": "Naam",
      "amount": "Bedrag",
      "title": "Fouten",
      "totalErrors": "Aantal fouten",
      "numberOfIncompletePayments": "Aantal incomplete betalingen",
      "total": "Totaal",
      "errorMessage": "Foutmelding"
    }
  },
  "actions": {
    "twikey": "Accorderen via Twikey",
    "completeTask": "Taak afronden"
  }
}
